import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
export default function Comp() {
    const { t } = useLang('theProduct.BannerA');
    const dataA: EcoBannerProps = {
        layout: 'top-center',

        pc: 'https://websiteoss.ecoflow.com/upload/image/1745042290771/first_kv_2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1745042290608/first_kv_2_h5.jpg',
        labelColor: '#D11504',
        title: t('title2'),
        desc: t('desc2'),

        // 按钮
        lType: 'filled',
        lChildren: t('btn2'),
        lHref: 'https://www.ecoflow.com/jp/portable-power-station-and-charger',
        lBtnIsYouToBe: false,

        // 按钮

        className: 'banner-card-b',
        lDataLayer: {
            event: 'uaEvent',
            event_name: 'select_product',
            list_name: 'Product Preview',
            product_name: 'portable-power-station-and-charger',
            button_name: t('btn1'),
        },
    };
    return (
        <>
            <EcoBanner {...dataA} />
        </>
    );
}
